export default "__VITE_ASSET__Bm6pcyBh__"